module.exports = __webpack_public_path__ + "static/media/brand-story-banner2.2ec184a3.png";